import React from 'react';
import { PlusOutlined, CloseCircleFilled } from '@ant-design/icons';
import { Button, Form, Input, Popconfirm, Select, Space, Typography, Checkbox } from 'antd';
import TextArea from 'antd/es/input/TextArea';


const { Text, Title, Paragraph } = Typography;


const AddingForm = ({ fields, remove, inputName, formValues }) => {
    return (
        <>
            {fields.map(({ key, name, ...restField }) => (
                <Space
                    key={key}
                    style={{
                        display: 'flex',
                        marginBottom: 8,
                    }}
                    align="baseline"
                >
                    <Form.Item
                        {...restField}
                        name={[name, 'inputedCodeValue']}

                    >
                        <Input style={{ width: "30vh" }} disabled defaultValue={formValues.codeValue} />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'inputedDescValue']}
                    >
                        <Input style={{ width: "30vh" }} disabled defaultValue={formValues.desc} />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'inputedPositionValue']}
                    >
                        <Input style={{ width: "30vh" }} disabled defaultValue={formValues.position} />
                    </Form.Item>
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => remove(name)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: '#92428B',
                                color: 'white',
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                    >
                        <CloseCircleFilled height={2} width={2} style={{ color: "#92428B", fontSize: "25px", fontWeight: "bolder" }} />
                    </Popconfirm>
                </Space>
            ))}
        </>
    )
}



const FormAddCodeValue = ({ formName, handleAdd, form, formData }) => {
    return (
        <>
            <Text strong style={{ fontSize: "15px", margin: "0px" }}>Add Code Value:</Text>
            <Form.Item
                name={"codeValue"}
                rules={[
                    {
                        required: true,
                        message: "Column value required",
                    },
                ]}
            >
                <Input style={{ width: "30vh" }} placeholder="Code Value" />
            </Form.Item>
            <Form.Item
                name={"desc"}
                rules={[
                    {
                        required: true,
                        message: 'enter description',
                    },
                ]}
            >
                <TextArea
                    placeholder='Description'
                    style={{ width: "30vh" }}></TextArea>
            </Form.Item>
            <Form.Item
                name={"position"}
                rules={[
                    {
                        required: true,
                        message: "position required",
                    },
                ]}
            >
                <Input style={{ width: "30vh" }} placeholder="Position" />
            </Form.Item>
            <Form.Item>
                <Checkbox>Active</Checkbox>
            </Form.Item>
            <Form.List name={formName}>
                {(fields, { add, remove }) => (
                    <>
                        <Button
                            onClick={() => {
                                const handleFormAdd = async () => {
                                    try {
                                        // Validating the additional input fields
                                        const newValues = form.validateFields(['codeValue', 'desc', 'position']);
                                        await newValues
                                        // If validation passes, add a new formList entry
                                        add();
                                        // If validation passes, add a new tableEditable Form in table
                                        handleAdd();
                                    } catch (errorInfo) {
                                        console.log('Validation failed:', errorInfo);
                                    }
                                };
                                handleFormAdd();
                            }}
                            type="primary"
                            icon={<PlusOutlined />}
                            style={{ backgroundColor: "#92428B", color: "white", width: "15vh", marginBottom: 20 }}
                        >Add</Button>
                        <AddingForm
                            fields={fields}
                            add={add}
                            remove={remove}
                            inputName={formName}
                            formValues={formData} />
                    </>
                )}
            </Form.List>
        </>
    );
};

export default FormAddCodeValue;

